import { render } from "./listDeprivedLibertyByPrisons.vue?vue&type=template&id=37c9e1c9"
import script from "./listDeprivedLibertyByPrisons.vue?vue&type=script&lang=js"
export * from "./listDeprivedLibertyByPrisons.vue?vue&type=script&lang=js"

import "./listDeprivedLibertyByPrisons.vue?vue&type=style&index=0&id=37c9e1c9&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__